// src/utils/rete.js

/**
 * Vero se l'errore viene dalla rete e non da una risposta del server.
 *
 * fetch() non restituisce un 401 quando non c'e' connessione: lancia un
 * TypeError, perche' la richiesta non e' proprio partita. Confondere le due
 * cose e' costoso, ed e' esattamente quello che succedeva qui: il catch di
 * una chiamata fallita chiamava logout(), cancellava il token e rimandava
 * al login. Risultato, aprire una pagina senza rete distruggeva la
 * sessione, e il tecnico in cantiere non poteva piu' rientrare.
 *
 * Un problema di rete non e' un problema di credenziali: non deve mai
 * far sloggare nessuno.
 */
export function eErroreDiRete(err) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;

  // fetch fallisce con TypeError quando la richiesta non parte
  return err instanceof TypeError;
}
